export const EMAIL_REQUIRED = "이메일을 입력해주세요.";
export const EMAIL_FORMAT = "이메일 형식을 확인해주세요.";
export const EMAIL_CHECK_REQUIRED = "이메일 중복 확인을 해주세요.";

export const PASSWORD_REQUIRED = "비밀번호를 입력해주세요.";
export const CURRENT_PASSWORD_REQUIRED = "현재 비밀번호를 입력해주세요.";
export const NEW_PASSWORD_REQUIRED = "변경하실 비밀번호를 입력해주세요.";
export const PASSWORD_FORMAT = "영문+숫자 조합 8~15자리를 입력해주세요.";
export const PASSWORD_CONFIRM_REQUIRED = "비밀번호를 다시 입력해주세요.";
export const PASSWORD_CONFIRM_INVALID = "비밀번호가 일치하지 않습니다.";

export const CURRENT_PASSWORD_INVALID = "현재 비밀번호와 일치하지 않습니다.";
export const CHANGE_PASSWORD_INVALID = "새 비밀번호와 일치하지 않습니다.";

export const SAME_PASSWORD_ENTERED =
  "현재 비밀번호와 변경하려는 비밀 번호가 같습니다.";

export const NAME_REQUIRED = "이름을 입력해주세요.";
export const ACCOUNT_REQUIRED = "계정 이메일을 입력해주세요.";
export const BIRTH_REQUIRED = "생년월일을 입력해주세요.";
export const PHONE_REQUIRED = "핸드폰 번호를 입력해주세요.";
export const VIDEO_LINK_REQUIRED = "숏폼영상 링크를 입력해주세요.";
export const SNS_LINK_REQUIRED = "SNS링크주소를 입력해주세요.";
export const CONTACT_PATH_ETC_REQUIRED = "공고를 확인한 매체를 입력해주세요.";
export const AI_TOOL_REQUIRED = "AI 활용 도구를 선택해주세요.";
export const CONTACT_PATH_REQUIRED = "공모전 참가경로를 선택해주세요.";
export const OTHER_CONTEST_NAME_REQUIRED = "타 공모전명을 입력해주세요.";

export const PHONE_FORMAT = "숫자만 입력해주세요.";
export const DIFFERENT_PHONE_INVALID = "기존 번호와 다른 번호를 입력해주세요.";
export const VERIFICATION_CODE_REQUIRED = "인증 번호를 입력해주세요.";
export const VERIFICATION_CODE_INVALID = "인증번호를 다시 확인해주세요.";
export const VERIFICATION_CODE_INCOMPLETE = "인증을 완료해주세요.";
export const PHONE_ALREADY_EXISTS = "이미 가입된 핸드폰 번호입니다.";
export const EMAIL_ALREADY_EXISTS = "이미 가입된 이메일입니다.";
export const PHONE_DOESNT_EXISTS =
  "회원 목록에 존재하지 않는 핸드폰 번호입니다.";
export const USE_TERM_REQUIRED = "이용약관에 동의해주세요.";
export const PRIVACY_POLICY_REQUIRED = "개인정보 처리방침에 동의해주세요.";
